import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const SUPABASE_FETCH_TIMEOUT_MS = 8000;

function installSupabaseFetchTimeout() {
  if (typeof window === "undefined") return;

  const key = "__zizanio_supabase_timeout_installed__";
  if ((window as any)[key]) return;

  const supabaseHost = (() => {
    try {
      return new URL(import.meta.env.VITE_SUPABASE_URL).host;
    } catch {
      return "";
    }
  })();

  if (!supabaseHost) return;

  const originalFetch = window.fetch.bind(window);

  window.fetch = (async (input: RequestInfo | URL, init?: RequestInit) => {
    const url =
      typeof input === "string"
        ? input
        : input instanceof URL
          ? input.toString()
          : input.url;

    if (!url.includes(supabaseHost)) {
      return originalFetch(input, init);
    }

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), SUPABASE_FETCH_TIMEOUT_MS);

    try {
      const mergedSignal = init?.signal
        ? ((AbortSignal as any).any?.([init.signal, controller.signal]) ?? init.signal)
        : controller.signal;

      return await originalFetch(input, {
        ...init,
        signal: mergedSignal,
      });
    } finally {
      clearTimeout(timeout);
    }
  }) as typeof window.fetch;

  (window as any)[key] = true;
}

installSupabaseFetchTimeout();

// Apply lite mode immediately on load (before React renders)
if (localStorage.getItem("zizanio_lite_mode") === "true") {
  document.body.classList.add("lite-mode");
}

createRoot(document.getElementById("root")!).render(<App />);
